import { Status } from "./status.model";
import { Course } from "./course.model";
import { User } from "./user.model";

export class CourseRegistration {
    id:number;
    status:Status;
    course:Course;
    user:User;
    
    constructor(data){
        this.id = data.registration_pk ? parseInt(data.registration_pk) : null;
        this.status = (data.casce_status) ? new Status(data.casce_status) : null;
        this.course = (data.casce_event) ? new Course(data.casce_event) : null;
        this.user = (data.casce_user) ? new User(data.casce_user) : null;
    }
}
